import React from "react";

export const LazyTradersMultiSelectAutoUpdateBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "SelectAutoUpdate" */ "./TradersMultiSelectAutoUpdate"
        )
);
